const LIST_SELECTOR = ".book-strip__list";
const ITEM_SELECTOR = ".book-strip__item";
const COUNT_VARIABLE = "--count";
const OVERLAP_VARIABLE = "--overlap";
const HOVER_X_VARIABLE = "--hover-x";
const HOVER_DURATION_VARIABLE = "--hover-duration";
const HOVER_RATIO_FROM_OVERLAP = 0.62;
const HOVER_MIN_PX = 14;
const HOVER_MAX_FROM_ITEM_RATIO = 0.32;
const HOVER_SPEED_PX_PER_SECOND = 70;
const HOVER_DURATION_MIN_MS = 220;
const HOVER_DURATION_MAX_MS = 420;

const updateListLayout = (listElement) => {
  const items = listElement.querySelectorAll(ITEM_SELECTOR);
  const parsedCount = Number(listElement.dataset.count);
  const fallbackCount = items.length;
  const count = Number.isFinite(parsedCount) && parsedCount > 0 ? parsedCount : fallbackCount;
  const safeCount = Math.max(1, count);

  listElement.style.setProperty(COUNT_VARIABLE, String(safeCount));

  if (safeCount <= 1 || items.length <= 1) {
    listElement.style.setProperty(OVERLAP_VARIABLE, "0rem");
    listElement.style.setProperty(HOVER_X_VARIABLE, "0rem");
    listElement.style.setProperty(HOVER_DURATION_VARIABLE, `${HOVER_DURATION_MIN_MS}ms`);
    return;
  }

  const listWidth = listElement.getBoundingClientRect().width;
  const itemWidth = items[0].getBoundingClientRect().width;
  const overlap = Math.max(0, (safeCount * itemWidth - listWidth) / (safeCount - 1));
  const hoverShift = Math.min(
    itemWidth * HOVER_MAX_FROM_ITEM_RATIO,
    Math.max(HOVER_MIN_PX, overlap * HOVER_RATIO_FROM_OVERLAP)
  );
  const durationMs = Math.min(
    HOVER_DURATION_MAX_MS,
    Math.max(HOVER_DURATION_MIN_MS, (hoverShift / HOVER_SPEED_PX_PER_SECOND) * 1000)
  );

  listElement.style.setProperty(OVERLAP_VARIABLE, `${overlap}px`);
  listElement.style.setProperty(HOVER_X_VARIABLE, `-${hoverShift}px`);
  listElement.style.setProperty(HOVER_DURATION_VARIABLE, `${durationMs}ms`);
};

export const initBookStripLayout = (rootElement = document) => {
  const lists = [...rootElement.querySelectorAll(LIST_SELECTOR)];

  if (lists.length === 0) {
    return;
  }

  const runLayout = () => {
    lists.forEach(updateListLayout);
  };

  runLayout();
  window.addEventListener("resize", runLayout);
};
